'use client'

import React from 'react'
import CartProvider from '../providers/CartProvider'
import { LanguageProvider } from '../providers/LanguageProvider'
import WishlistProvider from '../providers/WishlistProvider'
import MaintenancePage from '../themes/quickshop/components/MaintenancePage'
import Script from 'next/script'

const Providers = ({
  children,
  organizationData,
  currentPath,
  googleAnalyticsAccountKey,
  dynamicStyles,
  dir,
  domain,
  accountData,
  navigationData,
  footerData,
  homeData,
  announcementData,
  address,
  storeId,
  dictionaryList,
  currentTheme,
  underMaintenace,
  fbAnalyticsId,
  conversionArray,
  scriptBody,
}) => {
  return (
    // <GTMWrapper organizationData={organizationData}>
    // <CommonDataProvider
    //   defaultData={{
    //     organizationData,
    //     navigationData,
    //     footerData,
    //     homeData,
    //     announcementData,
    //   }}
    // >
    // <AddressProvider
    //   defaultAddress={{
    //     address,
    //     storeId: storeId || organizationData?.defaultStoreId,
    //     type: 'DELIVERY',
    //     ...(address?.storeName && { storeName: address.storeName }),
    //   }}
    //   organizationData={organizationData}
    // >
    <CartProvider>
      <LanguageProvider
        organizationData={{ ...organizationData }}
        dictionaryList={dictionaryList}
      >
        <WishlistProvider>
          {/* <ThemeNameProvider
                            currentTheme={currentTheme}
                            websiteTheme={websiteTheme}
                          > */}
          {underMaintenace ? (
            <MaintenancePage />
          ) : (
            <>
              {fbAnalyticsId && (
                <Script
                  id="facebook-analytics"
                  type="text/javascript"
                  strategy="lazyOnload"
                  dangerouslySetInnerHTML={{
                    __html: `
                                        !function(f,b,e,v,n,t,s)
                                        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                                        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                                        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                                        n.queue=[];t=b.createElement(e);t.async=!0;
                                        t.src=v;s=b.getElementsByTagName(e)[0];
                                        s.parentNode.insertBefore(t,s)}(window, document,'script',
                                        'https://connect.facebook.net/en_US/fbevents.js');
                                        fbq('init', '${fbAnalyticsId}');
                                        fbq('track', 'PageView');
                                      `,
                  }}
                />
              )}
              {conversionArray?.map((conversionScript, index) => {
                const setConversionScript =
                  index > 0 && conversionScript.split(/<\/script>/)
                return (
                  Boolean(setConversionScript) &&
                  setConversionScript.length && (
                    <Script
                      id="conversion-script"
                      strategy="lazyOnload"
                      defer
                      key={setConversionScript[0]}
                      dangerouslySetInnerHTML={{
                        __html: setConversionScript[0],
                      }}
                    />
                  )
                )
              })}
              {children}
              {scriptBody && (
                <Script
                  id="script-body"
                  type="text/javascript"
                  strategy="lazyOnload"
                  defer
                  dangerouslySetInnerHTML={{
                    __html: scriptBody,
                  }}
                />
              )}
            </>
          )}
          {/* </ThemeNameProvider> */}
        </WishlistProvider>
      </LanguageProvider>
    </CartProvider>
    // </AddressProvider>
    // </CommonDataProvider>
    // </GTMWrapper>
  )
}

export default Providers
